import { DateTime } from 'luxon';
import { IAutocompleteItem } from '../models/autocomplete-item.model';
import { MultiFacetType } from '../models/multi-facet-type.enum';
import type IMultiFacet from '../models/multi-facet.model';
import { TranslationService } from '../services/translation.service';
import { LineHelper } from './line.helper';

export class MultiFacetHelper {
  // NV-7205: At the moment we handle only municipality and line facets, but this can be extended in the future.

  public static getAutocompleteItemDisplayName(item: IAutocompleteItem | undefined): string | undefined {
    if (!item) return undefined;

    const autocompleteItem = item as IMultiFacet;

    if (autocompleteItem.type === MultiFacetType.Municipality && autocompleteItem.municipality) {
      return autocompleteItem.municipality.name;
    }
    if (autocompleteItem.type === MultiFacetType.Line && autocompleteItem.line) {
      let name = LineHelper.getLineNameAndDirection(autocompleteItem.line);
      if (autocompleteItem.line.appliesFrom && autocompleteItem.line.appliesFrom > DateTime.now()) {
        name = `${name} (${LineHelper.getAppliesFromText(autocompleteItem.line, TranslationService.get('common.from'))})`;
      }
      return name;
    }
    return undefined;
  }

  public static getAutocompleteItemId(item: IAutocompleteItem): string | undefined {
    const autocompleteItem = item as IMultiFacet;
    if (!autocompleteItem) return undefined;
    return autocompleteItem.type === MultiFacetType.Municipality ? autocompleteItem.municipality?.gid : autocompleteItem.line?.gid;
  }

  public static getSuggestionId(componentId: string, item: IAutocompleteItem): string | undefined {
    if (!item) return undefined;

    const autocompleteItem = item as IMultiFacet;

    if (autocompleteItem.type === MultiFacetType.Municipality && autocompleteItem.municipality) {
      return `autocomplete-result-item-${componentId}-${autocompleteItem.municipality.gid}`;
    }
    if (autocompleteItem.type === MultiFacetType.Line && autocompleteItem.line) {
      let appliesFrom = autocompleteItem.line.appliesFrom;
      // Defensive: appliesFrom may be a string or DateTime, ensure it's a DateTime
      if (appliesFrom && typeof appliesFrom === 'string') {
        appliesFrom = DateTime.fromISO(appliesFrom);
      }
      // Only call toFormat if appliesFrom is a Luxon DateTime instance
      if (DateTime.isDateTime(appliesFrom)) {
        return `autocomplete-result-item-${componentId}-${autocompleteItem.line.gid}-${appliesFrom.toFormat('yyyy-MM-dd')}`;
      }
      return `autocomplete-result-item-${componentId}-${autocompleteItem.line.gid}`;
    }
    return undefined;
  }
}
